/**
 * AI:
 * Status: 'in progress'
 * Type: Component
 * SubType: ObjectBaseModeComponent
 * Reason: Base view of the bank account overview OBC (layer 2 of the three-layer pattern of
 *         `cp-provision-type-matrix-object`). It declares only the navigation items; `full` and `side`
 *         inherit from it. It is never rendered itself, so its template file holds a comment only - kept as a
 *         separate file anyway (three-file rule, no inline template).
 *
 *         `ObjectBaseModeComponent` subscribes to `?navItem=` / `?sideNavItem=` and emits `onNavigationItems`
 *         on its own (`ngOnInit` → `handleNavigationItemsChange()`), so nothing is rebuilt here.
 *
 *         EXACTLY ONE navigation item: the overview IS the whole surface - base data on top, the billing
 *         accounts below. The item is declared all the same, because the frame renders the object header from
 *         it and a `?sideNavItem=` deep link has to resolve to something. Its action is deliberately
 *         `bankAccountOverview`, NOT `overview`: a generic action would collide with a `?navItem=overview` of
 *         the host page behind the drawer (lesson V13 of `cm-general-agency-obc`).
 *
 * @ticket TM-1000002030
 */
import {Component, OnInit} from '@angular/core';
import {NavigationItem} from 'features/core/shared/dto/navigation/navigation-item';
import {ObjectBaseModeComponent} from 'features/core/shared/object/mvs-object-base/object-base-mode.component';

/**
 * Navigation action of the one item. Never `overview` (see the class comment).
 *
 * @ticket TM-1000002030
 */
export const CR_BANK_ACCOUNT_OVERVIEW_NAV_ACTION = 'bankAccountOverview';

@Component({
    selector: 'cr-customer-bank-account-overview-base',
    templateUrl: './cr-customer-bank-account-overview-base.component.html',
    styleUrls: ['./cr-customer-bank-account-overview-base.component.scss'],
    standalone: false
})
export class CrCustomerBankAccountOverviewBaseComponent extends ObjectBaseModeComponent implements OnInit {

    /**
     * Navigation items of the overview. `action` (not `route`) is the key - it is matched against
     * `?navItem=` / `?sideNavItem=`.
     */
    override navigationItems: NavigationItem[] = [
        {
            label: 'Übersicht',
            action: CR_BANK_ACCOUNT_OVERVIEW_NAV_ACTION,
            tooltip: 'Basisdaten der Bankverbindung und die Abrechnungskonten, die sie nutzen',
            icon: 'fa-regular fa-building-columns',
            toggleable: false,
            default: true
        }
    ];

    override ngOnInit(): void {
        super.ngOnInit();
        this.initialized = true;
    }

}
